import REFERRAL_API from 'api/referral/v1'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import prepareFilterParams from 'utils/prepareFilterParams'
import {
  CLIENTS_FETCH,
  CLIENTS_SET_DATA,
  CLIENTS_UPDATE_CLIENT,
  CLIENTS_UPDATE_DATA,
} from 'modules/Referral/ReferralClients/types'
import { notificationShow } from 'modules/Notifications/actions'

function* referralClientsFetch({ payload }) {
  const {
    meta: { reject, resolve },
    page = 0,
    ...rest
  } = payload

  const { filters, pagination: { limit } = {} } = yield select(
    (state) => state['referral/clients'],
  )

  try {
    const { response, error } = yield call(REFERRAL_API.fetchClients, {
      params: prepareFilterParams({
        ...filters,
        offset: (page - 1) * limit,
        limit,
        ...rest,
      }),
    })

    if (error) {
      throw error
    }

    yield put({
      type: CLIENTS_SET_DATA,
      payload: {
        data: response.data,
        pagination: response.pagination,
      },
    })
    resolve(response)
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    reject()
    console.logXHR(error)
  }
}

function* referralClientsUpdateClient({ payload }) {
  const {
    meta: { reject, resolve },
    ...rest
  } = payload

  try {
    const { response, error } = yield call(REFERRAL_API.updateClient, {
      ...rest,
    })

    if (error) {
      throw error
    }

    yield put({
      type: CLIENTS_UPDATE_DATA,
      payload: response.data,
    })

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_stored',
        delay: 2000,
      }),
    )

    resolve()
  } catch (error) {
    const { form } = extractErrors(error.errors)

    yield put(
      notificationShow({
        type: 'error',
        message: form || 'common::notifications.data_fetch_failed',
      }),
    )
    reject()
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(CLIENTS_FETCH, referralClientsFetch)
  yield takeLatest(CLIENTS_UPDATE_CLIENT, referralClientsUpdateClient)
}
